import { useMemo } from 'react'

import { Drawer } from 'antd'

import { useBreakpoint } from '@/hooks/useBreakpoint'

export const SIDE_WIDTH = 256

type Props = {
  open: boolean
  forceDrawer?: boolean
  onClose: () => void
  children: (isDrawer: boolean) => React.ReactElement
}

export const CorePageSideNavWrapper: React.FC<Props> = ({
  open,
  forceDrawer,
  onClose,
  children,
}) => {
  const isMobile = useBreakpoint('lg')

  const showInDrawer = useMemo(() => {
    return forceDrawer ?? isMobile
  }, [forceDrawer, isMobile])

  if (!showInDrawer) return children(false)

  return (
    <Drawer
      width="100%"
      contentWrapperStyle={{ maxWidth: '90vw' }}
      placement="left"
      bodyStyle={{ padding: 0 }}
      closable={false}
      open={open}
      onClose={onClose}
    >
      {children(true)}
    </Drawer>
  )
}
